export const dataCenter = [
  {
    path: "/dataCenter/consume",
    name: "DataCenterConsume",
    component: () => import("@/views/dataCenter/index.vue"),
    meta: {
      title: "数据中心",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
];
// 按钮code映射
export const productsBtnMap = {
  productExport_76426757: "1861283974676426757", // 商品管理-导出
};
